import React from 'react'
import { AiFeaturePreset } from '../../../../../models/AiFeaturePreset'
import { MeetingTemplateCurrentUserInputParameterConfigForm } from '../../../../../components/InputParameterHierarchy/Form/MeetingTemplateCurrentUserInputParameterConfigForm'
import { MeetingTemplateTeamMemberInputParameterConfigForm } from '../../../../../components/InputParameterHierarchy/Form/MeetingTemplateTeamMemberInputParameterConfigForm'
import { MeetingTemplateInputParametersHierarchyConfigModal } from '../../../../../components/InputParameterHierarchy/MeetingTemplateInputParametersHierarchyConfigModal'
import { MeetingTemplateGlobalInputParameterConfigForm } from '../../../../../components/InputParameterHierarchy/Form/MeetingTemplateGlobalInputParameterConfigForm'
import { InputParameterHierarchyType } from '../../../../../components/InputParameterHierarchy/model'
import { useGlobalFormPresetInputParameters } from '../hooks'

export interface PresetConfigModalProps {
  show: boolean
  onHide: () => void
  preset: AiFeaturePreset
  meetingTemplateId: string
}

export const MeetingTemplatePresetFormConfigModal: React.FC<PresetConfigModalProps> = ({ show, onHide, preset, meetingTemplateId }) => {
  const { presetInputParameters } = useGlobalFormPresetInputParameters(preset)
  return (
    <MeetingTemplateInputParametersHierarchyConfigModal
      show={show}
      onHide={onHide}
      type={InputParameterHierarchyType.AI_FEATURE_PRESET}
      typeId={preset.id}
      name={preset.name}
      inputParametersSchema={preset.inputParametersSchema}
      defaultInputParameters={presetInputParameters}
      meetingTemplateId={meetingTemplateId}
      MeetingTemplateConfig={MeetingTemplateGlobalInputParameterConfigForm}
      CurrentUserConfig={MeetingTemplateCurrentUserInputParameterConfigForm}
      TeamMembersConfig={MeetingTemplateTeamMemberInputParameterConfigForm}
    />
  )
}
